import { useTranslation } from 'react-i18next';
import { useAuth, useSnack } from 'hooks';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Navigate, useNavigate } from 'react-router-dom';
import { forgotPassword } from 'api/auth';
import { TextField } from 'components/Fields';
import { KoobAuthCard, KoobButton } from '@koob/ui';

const LostAccess = () => {
  const { t } = useTranslation(['auth', 'errors']);
  const { accessToken } = useAuth();
  const { notify } = useSnack();
  const navigate = useNavigate();

  const handleForgotPassword = async (values) => {
    await forgotPassword(values);
    notify(t('forgotPassword.succeeded'));
  };

  if (Boolean(accessToken)) {
    return <Navigate to="/" />;
  }

  return (
    <KoobAuthCard
      title={t('forgotPassword.title')}
      subtitle={t('forgotPassword.subtitle')}
    >
      <Formik
        initialValues={{ email: '' }}
        validationSchema={Yup.object().shape({
          email: Yup.string().email().required(t('errors:required')),
        })}
        onSubmit={handleForgotPassword}
      >
        {({ isSubmitting }) => (
          <Form>
            <TextField
              label={t('email')}
              name="email"
              type="email"
              autoComplete="email"
            />

            <div className="mt-6">
              <KoobButton
                type="submit"
                variant="navy"
                size="lg"
                block
                loading={isSubmitting}
              >
                {t('forgotPassword.button')}
              </KoobButton>
            </div>
          </Form>
        )}
      </Formik>

      <div className="mt-4 text-center">
        <KoobButton variant="ghost" size="sm" onClick={() => navigate(-1)}>
          {t('forgotPassword.goBack')}
        </KoobButton>
      </div>
    </KoobAuthCard>
  );
};

export default LostAccess;
